{
  "register-success-page": {
    "buttons": {
      "start": "Losgehen"
    },
    "text": {
      "account-created": "Konto erstellt",
      "account-created-hint": "Ihr Konto wurde erstellt! Sie können sich jetzt einloggen und unser Buchungssystem nutzen"
    }
  }
}
